
/**
 * Get variant price and price compare from input variant
 * Update variant price and compare to front
 * @param {element} variantInput 
 */
const updatePrice = (variantInput) => {
  const productCard = document.querySelector(`[data-product-id="product-card--${variantInput.getAttribute('data-product-id')}"]`)
  console.log({productCard})
  const price = productCard.querySelector('.js-productcard-price')
  const priceCompare = productCard.querySelector('.js-productcard-price-compare')

  if (price) price.textContent = variantInput.getAttribute('data-price')
  if (priceCompare) priceCompare.textContent = variantInput.getAttribute('data-price-compare')
}

/**
 * Update id when select variant change
 * Active button to add to cart
 * @param {element} variantInput 
 */
const updateIds = (variantInput) => {
  const button = document.querySelector(`#button_submit_id-${variantInput.getAttribute('data-product-id')}`)
  const inputProductId = document.querySelector(`#input_swatche_id-${variantInput.getAttribute('data-product-id')}`)

  if (button) button.removeAttribute('disabled');
  if (inputProductId) inputProductId.setAttribute('value', variantInput.getAttribute('data-id'));
}

const updateImage = (variantInput) => {
  const image1Url = variantInput.getAttribute('data-image');
  const image2Url = variantInput.getAttribute('data-image2');

  const productCardSelector = `product-card--${variantInput.getAttribute('data-product-id')}`;
    
  let container = document.getElementById(productCardSelector);
  let image = container.querySelector('.master-image-bought');
  let image2 = container.querySelector('.hover-image-bought');

  if (image && image1Url) {
    image.src = image1Url;
    image.srcset = '';
  }

  if (image2 && image2Url) {
    image2.src = image2Url;
    ;
  }

  console.log(image, image2)
};


/**
 * Get all product cards to manage select variant:
 * Update variant ids
 * Update price and compare price to variant
 */
const varianSelect = () => {
  const swatches = document.querySelectorAll('.productitem--swatches-input');

  swatches && swatches.forEach((swatch) => {
    swatch.addEventListener('change', function() {
      if (this.hasAttribute('data-product-id') && this.hasAttribute('data-id')) {
        updateIds(this)
        updatePrice(this)
        updateImage(this)
      }
    })

    swatch.addEventListener('keydown', function() {
      const nextSwatch = this.nextElementSibling;
      if ((event.key === 'Enter' || event.key === ' ') && nextSwatch) {
        event.preventDefault();
        nextSwatch.click();
      }
    });
  })
}

varianSelect()